import React, { useContext, FC } from "react";
import { Flag, Connected } from "../types";
import { updateFlag, refreshMyProfile } from "../actions";
import UserContext from "../contexts/userContext";
import { History } from "history";
import withRedux from "../withRedux";
import { _ } from "libs";
import PasswordChangeForm from "../components/passwordChangeForm";

type Props = {
	history: History;
	refreshMyProfile: Connected<typeof refreshMyProfile>;
};

const AlterPassword: FC<Props> = ({ history, refreshMyProfile }: Props) => {
	const { profile } = useContext(UserContext);

	if (profile.flags && profile.flags.mustAlterPassword === 0) {
		history.push("/");
	}

	const changeCallback = async () => {
		await updateFlag(Flag.MustAlterPassword, 0);
		await refreshMyProfile();
		history.push("/");
	};

	return (
		<div className="boxWrap">
			<div className="box alterPassword">
				<div className="boxLeader">
					<div className="symbol lock" />
					<h2>{_("alterPassword.heading")}</h2>
				</div>
				<div className="boxContent">
					<p className="description">{_("alterPassword.description")}</p>
					<PasswordChangeForm callback={changeCallback} />
				</div>
			</div>
		</div>
	);
};

export default withRedux({ refreshMyProfile }, null)(AlterPassword);
